import { TableList } from '../../table-list/TableList';

export const BaseSideBar = () => {
  return <TableList />;
};
